<div class="dropdown col-sm-12">
	<button class="btn btn-ef btn-sm dropdown-toggle" type="button" data-toggle="dropdown" style="margin-bottom: 10px">
		<i class="fa fa-info-circle" aria-hidden="true"></i>
		KEYWORDS
		<span class="caret"></span>
	</button>
	<ul class="dropdown-menu">
		<li *ngFor="let keyword of mAvailableKeywords" onmousedown="return false;" (click)="addKeyword(keyword)">
			<a style="cursor: pointer;">
				<i [ngClass]="keyword.classes" aria-hidden="true"></i>
				{{keyword.name}}
			</a>
		</li>
	</ul>
</div>
<div class="col-sm-12">
	<div class="panel panel-drk-ornge" style="border-color: #f57300">
		<div class="panel-body">
			<div 
				id="dialogMessage_{{mUniqueIndex}}"
				contenteditable="true"
				[(appContentEditable)]="mDialog.message"
				[keywords]="mAvailableKeywords"
				(modelChange)="updateMessage($event);"
				class="form-control eftextarea" 
				style="min-height: 163px; font-size: 18px; width: auto"
				>
			</div>
		</div>
	</div>
</div>